export class PermissionNode {
    levelModulePermissionId: string;
    name: string;
    urlSgc1: string;
    urlSgc2: string;
    redirectToSgc1: boolean;
    level0: boolean | 'indeterminate';
    level1: boolean | 'indeterminate';
    level2: boolean | 'indeterminate';
    level3: boolean | 'indeterminate';
    level4: boolean | 'indeterminate';
    level5: boolean | 'indeterminate';
    level6: boolean | 'indeterminate';
    childrens: PermissionNode[];
    isExpanded: boolean;
    isEdited: boolean;
    index: number;
}